import InfoIcon from '@mdi/svg/svg/information-outline.svg?react';
import { MDIIcon } from '@solinkcorp/solink-components';
import classNames from 'classnames';
import React from 'react';
import styles from './SpotCheckCard.module.sass';

interface SpotCheckCardProps {
  title: string;
  onClick?: () => void;
  templateThumbnail?: string;
  description?: string;
}
export default function SpotCheckCard(props: SpotCheckCardProps) {
  const { title, onClick, templateThumbnail, description } = props;
  const [isInfoHovered, setIsInfoHovered] = React.useState(false);

  const handleMouseEnter = () => setIsInfoHovered(true);
  const handleMouseLeave = () => setIsInfoHovered(false);

  return (
    <div className={styles.spotCheckCard} onClick={onClick}>
      <div className={styles.spotCheckCardImageWrapper}>
        <img src={templateThumbnail} />
        <div className={classNames(styles.imageOverlay, { [styles.visible]: isInfoHovered })}>
          {description}
        </div>
      </div>
      <div className={styles.spotCheckCardTitleWrapper}>
        {title}
        <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
          <MDIIcon icon={InfoIcon} size={18} />
        </div>
      </div>
    </div>
  );
}
